import { TariffPlanOutputWithStatus } from './tariff-plan-output-with-status.model';


export class TariffPlanSelectByIdOutput implements ITariffPlanSelectByIdOutput {
    status!: number;
    message!: string;
    data!: TariffPlanOutputWithStatus;

    constructor(data?: ITariffPlanSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? TariffPlanOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TariffPlanSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TariffPlanSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITariffPlanSelectByIdOutput {
    status: number;
    message: string;
    data: TariffPlanOutputWithStatus;
}

